import React from 'react';
import classNames from 'classnames';

import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';

import { randomString } from 'services/base/random';

import baseStyles from './stripe.module.css';

type StripeStyles = {
  filler: string;

  paymentElementProgressAccordion: string;
  paymentElementProgressAccordionItem: string;
  paymentElementProgressAccordionRow: string;
  paymentElementProgressAccordionColumn: string;
  paymentElementProgressAccordionTitle: string;
  paymentElementProgressAccordionLabel: string;
  paymentElementProgressAccordionInput: string;
};

const themedStyles: ThemedStyles<StripeStyles> = {
  [Theme.DAYLIGHT]: {
    filler: baseStyles.daylightFiller,

    paymentElementProgressAccordion: baseStyles.daylightPaymentElementProgressAccordion,
    paymentElementProgressAccordionItem: baseStyles.daylightPaymentElementProgressAccordionItem,
    paymentElementProgressAccordionRow: baseStyles.paymentElementProgressAccordionRow,
    paymentElementProgressAccordionTitle: baseStyles.paymentElementProgressAccordionTitle,
    paymentElementProgressAccordionColumn: baseStyles.paymentElementProgressAccordionColumn,
    paymentElementProgressAccordionLabel: baseStyles.paymentElementProgressAccordionLabel,
    paymentElementProgressAccordionInput: baseStyles.paymentElementProgressAccordionInput,
  },
  [Theme.MIDNIGHT]: {
    filler: baseStyles.midnightFiller,

    paymentElementProgressAccordion: baseStyles.midnightPaymentElementProgressAccordion,
    paymentElementProgressAccordionItem: baseStyles.midnightPaymentElementProgressAccordionItem,
    paymentElementProgressAccordionRow: baseStyles.paymentElementProgressAccordionRow,
    paymentElementProgressAccordionTitle: baseStyles.paymentElementProgressAccordionTitle,
    paymentElementProgressAccordionColumn: baseStyles.paymentElementProgressAccordionColumn,
    paymentElementProgressAccordionLabel: baseStyles.paymentElementProgressAccordionLabel,
    paymentElementProgressAccordionInput: baseStyles.paymentElementProgressAccordionInput,
  },
};

export const StripePaymentElementProgress = () => {
  const styles = useStyles(themedStyles);
  return (
    <div className={styles.paymentElementProgressAccordion}>
      <div className={styles.paymentElementProgressAccordionItem}>
        <div className={styles.paymentElementProgressAccordionRow}>
          <div className={styles.paymentElementProgressAccordionColumn}>
            <div className={classNames(styles.paymentElementProgressAccordionTitle, styles.filler)}>
              {randomString(15, 20)}
            </div>
          </div>
        </div>
        <div className={styles.paymentElementProgressAccordionRow}>
          <div className={styles.paymentElementProgressAccordionColumn}>
            <div className={classNames(styles.paymentElementProgressAccordionLabel, styles.filler)}>
              Card Number
            </div>
            <div className={classNames(styles.paymentElementProgressAccordionInput, styles.filler)}>
              &nbsp;
            </div>
          </div>
        </div>
        <div className={styles.paymentElementProgressAccordionRow}>
          <div className={styles.paymentElementProgressAccordionColumn}>
            <div className={classNames(styles.paymentElementProgressAccordionLabel, styles.filler)}>
              Expiration
            </div>
            <div className={classNames(styles.paymentElementProgressAccordionInput, styles.filler)}>
              &nbsp;
            </div>
          </div>
          <div className={styles.paymentElementProgressAccordionColumn}>
            <div className={classNames(styles.paymentElementProgressAccordionLabel, styles.filler)}>
              CVC
            </div>
            <div className={classNames(styles.paymentElementProgressAccordionInput, styles.filler)}>
              &nbsp;
            </div>
          </div>
        </div>
        <div className={styles.paymentElementProgressAccordionRow}>
          <div className={styles.paymentElementProgressAccordionColumn}>
            <div className={classNames(styles.paymentElementProgressAccordionLabel, styles.filler)}>
              Country
            </div>
            <div className={classNames(styles.paymentElementProgressAccordionInput, styles.filler)}>
              &nbsp;
            </div>
          </div>
        </div>
        <div className={styles.paymentElementProgressAccordionRow}>
          <div className={styles.paymentElementProgressAccordionColumn}>
            <div className={classNames(styles.paymentElementProgressAccordionInput, styles.filler)}>
              <br/><br/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
